// extracted by mini-css-extract-plugin
export default {"symbol":"PhoneNumberInput_symbol__PZebs"};